
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jeux/sudoku",
      function () {
        return require("private-next-pages/jeux/sudoku.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jeux/sudoku"])
      });
    }
  